/* eslint-disable @typescript-eslint/naming-convention */
import fileDownload from 'js-file-download';

import {ThunkActionType} from 'store/types';
import request, {WISBIT_ORGANIZATION} from 'api/requests/request';

import {OrganizationDTO} from 'api/typesDTO/organisationDTO';
import {
  convertOrganizationToOrganizationDTO,
  convertOrganizationDTOToOrganization,
} from 'api/converters/organisationConverters';

import {USER_TYPE} from 'containers/ManageUserPage/userType';
import {User} from 'api/types/userTypes';
import {UserDTO} from 'api/typesDTO/userDTO';
import {convertUserDTOToUser} from 'api/converters/userConverters';

import {Organization} from 'api/types/organisationTypes';
import {
  loadOrganizationsRequest,
  loadOrganizationsFailure,
  loadOrganizationsSuccess,
  addOrganizationRequest,
  addOrganizationFailure,
  addOrganizationSuccess,
  editOrganizationRequest,
  editOrganizationSuccess,
  editOrganizationFailure,
  deleteOrganizationRequest,
  deleteOrganizationSuccess,
  deleteOrganizationFailure,
  downloadResultsRequest,
  downloadResultsFailure,
} from './actions';
import {ROLE} from 'api/constants';

export const loadOrganizationsThunk =
  (): ThunkActionType => async (dispatch, getState) => {
    dispatch(loadOrganizationsRequest());

    try {
      const {
        app: {
          user: {
            role = ROLE.manager,
            organization: {id: organizationId = ''} = {},
          } = {},
        } = {},
      } = getState();

      let organizationDTOs: OrganizationDTO[] = [];
      let userDTOs: UserDTO[] = [];

      if (role === ROLE.manager && organizationId) {
        const response = await request(`/organization/${organizationId}`);

        userDTOs = await request('/user');

        organizationDTOs = [response];
      } else {
        const response = await request('/organization');
        organizationDTOs = response;

        userDTOs = await request('/user', {
          headers: {
            [WISBIT_ORGANIZATION]: '',
          },
        });
      }

      const users: User[] = userDTOs.map(userDTO =>
        convertUserDTOToUser(userDTO)
      );

      const items: Organization[] = organizationDTOs.map(
        (organization: OrganizationDTO) => ({
          ...convertOrganizationDTOToOrganization(organization),
          currentManagers: users.filter(
            ({role, organization: {id} = {}}) =>
              id === organization.id && role === USER_TYPE.ADMIN.id
          ).length,
          currentContentCreators: users.filter(
            ({role, organization: {id} = {}}) =>
              id === organization.id && role === USER_TYPE.CONTENT_CREATOR.id
          ).length,
          currentLearners: users.filter(
            ({role, organization: {id} = {}}) =>
              id === organization.id && role === USER_TYPE.LEARNER.id
          ).length,
        })
      );

      dispatch(loadOrganizationsSuccess(items));
      /* eslint-disable-next-line  @typescript-eslint/no-explicit-any */
    } catch (error: any) {
      dispatch(loadOrganizationsFailure(error));
    }
  };

export const addOrganization =
  (newOrganization: Organization): ThunkActionType =>
  async dispatch => {
    dispatch(addOrganizationRequest());

    try {
      const response = await request('/organization', {
        method: 'POST',
        data: convertOrganizationToOrganizationDTO(newOrganization),
      });

      const organization = {
        ...convertOrganizationDTOToOrganization(response),
        currentManagers: 0,
        currentContentCreators: 0,
        currentLearners: 0,
      };

      dispatch(addOrganizationSuccess(organization));
      /* eslint-disable-next-line  @typescript-eslint/no-explicit-any */
    } catch (error: any) {
      dispatch(addOrganizationFailure(error));
    }
  };

export const editOrganization =
  (currentOrganization: Organization): ThunkActionType =>
  async dispatch => {
    dispatch(editOrganizationRequest());

    try {
      const response = await request(
        `/organization/${currentOrganization.id}`,
        {
          method: 'PUT',
          data: {
            ...convertOrganizationToOrganizationDTO(currentOrganization),
            id: null,
          },
        }
      );

      console.log(response);

      dispatch(editOrganizationSuccess(currentOrganization));
      /* eslint-disable-next-line  @typescript-eslint/no-explicit-any */
    } catch (error: any) {
      dispatch(editOrganizationFailure(error));
    }
  };

export const deleteOrganization =
  (currentOrganization: Organization): ThunkActionType =>
  async dispatch => {
    dispatch(deleteOrganizationRequest());

    try {
      const response = await request(
        `/organization/${currentOrganization.id}`,
        {
          method: 'DELETE',
        }
      );

      console.log(response);

      dispatch(deleteOrganizationSuccess(currentOrganization));
      /* eslint-disable-next-line  @typescript-eslint/no-explicit-any */
    } catch (error: any) {
      dispatch(deleteOrganizationFailure(error));
    }
  };

export const downloadResult =
  (organizationId: string): ThunkActionType =>
  async dispatch => {
    dispatch(downloadResultsRequest());

    try {
      const response = await request('/statistics/organization', {
        responseType: 'blob',
        headers: {
          [WISBIT_ORGANIZATION]: organizationId,
        },
      });

      fileDownload(response, 'organization-results.csv');
      /* eslint-disable-next-line  @typescript-eslint/no-explicit-any */
    } catch (error: any) {
      dispatch(downloadResultsFailure(error));
    }
  };
